export default "__VITE_PUBLIC_ASSET__42932d65__"